import React, { Component } from 'react';
import { Modal, Button, Spin, message } from 'antd';
import ExportUtil from '../../../../common/ExportUtil';
import TableC from '../../../basicElement/TableC';
import UploadFile from '../../../common/UploadFile';
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';
import $ from 'jquery';

let editable = false;
let timestamp = undefined;
const uploadType = 'REQUEST_FUNDS_MANUAL';

class RequestHandbook extends Component {
    state = {
        visible: false,
        loading: false,
        data: [],
        record: {},
    }

    loadData = () => {
        const { record: { customerCompanyId } } = this.state;
        this.setState({ loading: true });
        Fetch.post(API_URL.common.queryEnclosureFileList, {
            uploadType,
            relateId: customerCompanyId
        }).then(res => {
            const data = res.datas || [];
            this.setState({
                data,
                loading: false,
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    show = (record, bool) => {
        editable = bool;
        timestamp = Date.now();
        this.setState({
            record,
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ visible: false }, () => {
            $('.tableC .transferCompany .ant-table-body').scrollTop(0);
        });
    }

    handleDelete = (record) => {
        this.setState({ loading: true });
        Modal.confirm({
            iconType: 'exclamation-circle',
            title: "确定删除该附件？",
            onOk: () => {
                const { fileMateId } = record;
                Fetch.post(API_URL.common.deleteEnclosureFile, {
                    fileMetaId: fileMateId,
                }).then((res) => {
                    message.success(res.success);
                    this.setState({ loading: false }, () => {
                        this.loadData();
                    });
                }).catch(err => {
                    console.error(err);
                    this.setState({ loading: false });
                });
            },
            onCancel: () => {
                this.setState({ loading: false });
            }
        });
    }

    downLoadFile = (fileMetaId) => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({ fileMetaId }, null, url);
    }

    getColumns = () => {
        const columns = [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            width: 100,
        }, {
            title: '附件名称',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => {
                const { fileMateId, name } = record;
                return <a onClick={() => this.downLoadFile(fileMateId)}>{name}</a>
            }
        }];
        if (editable) {
            columns.push({
                title: '操作',
                dataIndex: 'operation',
                key: 'operation',
                width: 80,
                render: (text, record) => <a onClick={() => this.handleDelete(record)}>删除</a>
            })
        }
        return columns;
    }

    render() {
        const { visible, loading, data, record } = this.state;
        const { customerCompanyName, customerCompanyId } = record;
        return (
            <Modal
                title="请款手册"
                visible={visible}
                onCancel={this.hide}
                maskClosable={false}
                confirmLoading={loading}
                width="600px"
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <Spin spinning={loading}>
                    <div style={{ position: 'relative', marginBottom: 10, paddingRight: 90, height: 28, lineHeight: '28px' }}>
                        客户名称：{customerCompanyName}
                        {
                            editable &&
                            <UploadFile
                                data={{
                                    uploadType,
                                    path: timestamp,
                                    relateId: customerCompanyId
                                }}
                                showUploadList={false}
                                style={{ position: 'absolute', top: 0, right: 0 }}
                                uploadUrl={API_URL.common.uploadEnclosureFile}
                                disabled={(data || []).length >= 10}
                                onChange={this.loadData}
                                type="primary"
                                text="上传附件"
                            />
                        }
                    </div>
                    <TableC
                        scrollY={220}
                        data={data}
                        columns={this.getColumns()}
                        onChange={this.handleTableChange}
                        className="requestHandbook"
                        rowKey="fileMateId"
                    />
                </Spin>
            </Modal>
        );
    }
}


export default RequestHandbook;


// WEBPACK FOOTER //
// ./src/components/contractManagement/responseCustomer/Components/RequestHandbook.js